// extracted by mini-css-extract-plugin
export default {"root":"RelationsTable_root__1uPGy","table":"RelationsTable_table__MJ3NO"};